import * as React from 'react';
import { cn } from '../../lib/utils.js';

const Table = React.forwardRef(({ className, ...props }, ref) => (
  <div className="relative w-full overflow-auto" data-astryx-table="">
    <table className={cn('w-full caption-bottom text-sm', className)} ref={ref} {...props} />
  </div>
));
Table.displayName = 'Table';

const TableHeader = React.forwardRef(({ className, ...props }, ref) => (
  <thead className={cn('[&_tr]:border-b border-[var(--color-border,var(--border))] bg-[var(--surface-container-low)]', className)} ref={ref} {...props} />
));
TableHeader.displayName = 'TableHeader';

const TableBody = React.forwardRef(({ className, ...props }, ref) => (
  <tbody className={cn('[&_tr:last-child]:border-0', className)} ref={ref} {...props} />
));
TableBody.displayName = 'TableBody';

const TableFooter = React.forwardRef(({ className, ...props }, ref) => (
  <tfoot className={cn('border-t border-[var(--color-border,var(--border))] bg-[var(--surface-container-low)] font-medium [&>tr]:last:border-b-0', className)} ref={ref} {...props} />
));
TableFooter.displayName = 'TableFooter';

const TableRow = React.forwardRef(({ className, ...props }, ref) => (
  <tr
    className={cn('border-b border-[var(--color-border,var(--border))] transition-colors hover:bg-[var(--surface-container-low)]/50 data-[state=selected]:bg-[var(--surface-container)]', className)}
    ref={ref}
    {...props}
  />
));
TableRow.displayName = 'TableRow';

const TableHead = React.forwardRef(({ className, ...props }, ref) => (
  <th className={cn('h-10 px-4 text-left align-middle font-bold text-[var(--color-text-primary,var(--foreground))] [&:has([role=checkbox])]:pr-0', className)} ref={ref} {...props} />
));
TableHead.displayName = 'TableHead';

const TableCell = React.forwardRef(({ className, ...props }, ref) => (
  <td className={cn('p-4 align-middle text-[var(--color-text-primary,var(--foreground))] [&:has([role=checkbox])]:pr-0', className)} ref={ref} {...props} />
));
TableCell.displayName = 'TableCell';

const TableCaption = React.forwardRef(({ className, ...props }, ref) => (
  <caption className={cn('mt-4 text-sm text-[var(--color-text-secondary,var(--secondary))]', className)} ref={ref} {...props} />
));
TableCaption.displayName = 'TableCaption';

export {
  Table,
  TableHeader,
  TableBody,
  TableFooter,
  TableHead,
  TableRow,
  TableCell,
  TableCaption,
};
